module.exports = __webpack_public_path__ + "img/ИФ-1(А)-042-m.8b368ad7.png";